﻿import React, {HTMLInputAutoCompleteAttribute, JSX} from "react";
import {MvvmPrefixedControlProps} from "./MvvmControlProps";
import MvvmInput from "./MvvmInput";

export type MvvmTextInputType =
	"text"
	| "color"
	| "email"
	| "month"
	| "password"
	| "search"
	| "tel"
	| "url"
	| "week";

export type MvvmTextInputProps<T extends object = never> = MvvmPrefixedControlProps<T, string> & {
	type: MvvmTextInputType;
	minLength?: number;
	maxLength?: number;
	autoComplete?: HTMLInputAutoCompleteAttribute;
	autoCapitalize?: "off" | "none" | "on" | "sentences" | "words" | "characters" | undefined | (string & {});
	enterKeyHint?: "enter" | "done" | "go" | "next" | "previous" | "search" | "send" | undefined;
	inputMode?: "none" | "text" | "tel" | "url" | "email" | "numeric" | "decimal" | "search" | undefined;
	validateOnChange?: boolean;
};

const updateMap:Map<string, boolean> = new Map([
	["text", false],
	["email", false],
	["password", false],
	["search", false],
	["tel", false],
	["url", false],
	["color", true],
	["month", true],
	["week", true]
])

export default function MvvmTextInput<T extends object = never>(props: MvvmTextInputProps<T>): JSX.Element {
	return <MvvmInput<T, string> control={props}
	                             type={props.type}
	                             updateOnChange={props.validateOnChange ?? updateMap.get(props.type) ?? false}
	                             maxLength={props.maxLength}
	                             minLength={props.minLength}
	                             autoComplete={props.autoComplete}
	                             autoCapitalize={props.autoCapitalize}
	                             enterKeyHint={props.enterKeyHint}
	                             inputMode={props.inputMode}
	                             valueToString={function (value: string | undefined): string {
		                             return value ?? "";
	                             }}
	                             valueFromString={function (value: string | undefined): string {
		                             return value ?? "";
	                             }}/>;
};
